import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Azuredevopstemplate from "../../component/course/azure-devops";


export default class Azuredevopsinnagercoil extends Component {

  render() {
    
    const title ="Azure DevOps"
    const url ="azure-devops"
    const url1 ="-training-in-nagercoil"
    const location = "nagercoil" 
    const location1="Training in Nagercoil"

    return (
      <>
          <NextSeoModule
             title={`${title} ${location1} - learnsoft.org `}
            description={`Join the best Azure DevOps ${location1} and become an expert in the field. Get certified and advance your career with our comprehensive courses, hands-on experience, and expert instructors.`}
            url={`${location}/${url}${url1}`}
            img={`course/${url}.webp`}
            keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}          />         
        <Layout navbarBackgroundColor="#281E1E">
          <Azuredevopstemplate url={url} title={title} url1={url1} relatedlocation={location} location={location} location1={location1} />
     </Layout>
      </>
    );
  }
}
